function game_1007()
{

}
game_1007.read_odd = function(id)
{
  if(id === 1)
  {
    return "2";
  }
  else if(id === 2)
  {
    return "2";
  }
  else if(id === 3)  {
    return "3";
  }
  else if(id === 4)  {
    return "4";
  }
  else if(id === 5){
    return "5";
  }
  else if(id === 6){
    return "6";
  }
  else if(id === 7){
    return "7";
  }
  else if(id === 8){
    return "8";
  }
  else if(id === 9){
    return "9";
  }
  else if(id === 10){
    return "10";
  }
  else if(id === 11){
    return "12";
  }
  else if(id === 12){
    return "15";
  }
  else if(id === 13){
    return "18";
  }
  else if(id === 14){
    return "20";
  }
  else if(id === 15){
    return "25";
  }
  else if(id === 50){
    return "30";
  }
  else if(id === 51){
    return "40";
  }
  else if(id === 52){
    return "60";
  }
  else if(id === 53){
    return "100";
  }
  else if(id === 54){
    return "174";
  }
  else if(id === 55){
    return "100";
  }
  else if(id === 56){
    return "120";
  }
  else if(id === 57){
    return "120-600";
  }
  else if(id === 58){
    return "60";
  }
  else if(id === 59){
    return "20";
  }
  else if(id === 61){
    return "80-200";
  }

  else if(id === 71){
    return "30";
  }
  else if(id === 72){
    return "30";
  }
  else if(id === 73){
    return "30";
  }
  else if(id === 73){
    return "30";
  }
  else if(id === 74){
    return "30";
  }
  else if(id === 75){
    return "30";
  }
  else if(id === 76){
    return "30";
  }
  else if(id === 77){
    return "30";
  }
  else if(id === 78){
    return "30";
  }
  else if(id === 79){
    return "30";
  }
  else if(id === 80){
    return "30";
  }
  else if(id === 81){
    return "30";
  }
  else if(id === 82){
    return "30";
  }
  else if(id === 83){
    return "30";
  }
  else if(id === 84){
    return "30";
  }
  else if(id === 85){
    return "30";
  }

  return  "";
}

export {
  game_1007
};



// WEBPACK FOOTER //
// ./src/components/fish/game_1007.js